import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/firestore';
import {SessionService} from './session.service';
import {CommonService} from './common.service';
import {MessageService} from './message.service';
import {
  COLLECTION_NAME,
  DEBEAK,
  DEBEAK_KANA,
  DEFAULT_JISSHIDATE,
  DOCUMENT_NAME,
  EVENT_GUARD_ERROR,
  EVENT_JISSHI_PROPERTIES,
  EVENT_SHUBETSU_LIST,
  NYUUKA,
  NYUUKA_KANA,
  OTHER,
  OTHER_KANA,
  SAIKETSU,
  SAIKETSU_KANA,
  SAIZAI,
  SAIZAI_KANA,
  SHIYOULOT_KEY_SUFFIX,
  SHUBETSU,
  SHUKKA, SHUKKA_EVENT_NAME,
  SHUKKA_KANA,
  TAISOKU,
  TAISOKU_KANA,
  TOUYO_HOUHOU,
  VACCINE,
  VACCINE_KABU,
  VACCINE_KANA
} from '../../shared/constants';
import firebase from 'firebase';
import {MasterService} from './master.service';
import {firstValueFrom, Observable, Subscription} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import cloneDeep from 'lodash-es/cloneDeep';
import {NyuukaEventDialogComponent} from '../../shared/dialog/nyuuka-event-dialog/nyuuka-event-dialog.component';
import {ShukkaEventDialogComponent} from '../../shared/dialog/shukka-event-dialog/shukka-event-dialog.component';
import {VaccineEventDialogComponent} from '../../shared/dialog/vaccine-event-dialog/vaccine-event-dialog.component';
import {SaizaiEventDialogComponent} from '../../shared/dialog/saizai-event-dialog/saizai-event-dialog.component';
import {SaiketsuEventDialogComponent} from '../../shared/dialog/saiketsu-event-dialog/saiketsu-event-dialog.component';
import {TaisokuEventDialogComponent} from '../../shared/dialog/taisoku-event-dialog/taisoku-event-dialog.component';
import {OtherEventDialogComponent} from '../../shared/dialog/other-event-dialog/other-event-dialog.component';
import {CloudStorageService} from './cloud-storage.service';
import {DebeakEventDialogComponent} from '../../shared/dialog/debeak-event-dialog/debeak-event-dialog.component';
import {Feed, Feed2} from '../../shared/interfaces/feed';
import {VaccineEvent} from '../../shared/interfaces/vaccine-event';
import {AbstractEvent} from '../../shared/interfaces/abstract-event';
import {SaizaiEvent} from '../../shared/interfaces/saizai-event';
import {SaiketsuEvent} from '../../shared/interfaces/saiketsu-event';
import {DebeakEvent} from '../../shared/interfaces/debeak-event';
import {
  EventForEdit,
  EventShubetsu,
  exceptKeyWithOptional,
  JisshiDateNonNullable,
  Mutable,
  TouyoHouhous,
  WithChecked,
  WithNullable,
  yyyyMMdd
} from '../../shared/typeAliases';
import {NyuukaEvent} from '../../shared/interfaces/nyuuka-event';
import {ShukkaEvent} from '../../shared/interfaces/shukka-event';
import {OtherEvent} from '../../shared/interfaces/other-event';
import {TaisokuEvent} from '../../shared/interfaces/taisoku-event';
import {genFeedDefaultValue, KeishaHibetsuFileService} from './keisha-hibetsu-file.service';
import {ShiyoulotHibetsuFileService} from './shiyoulot-hibetsu-file.service';

// Firestoreの1トランザクションあたり書き込み上限(500)に対する安全マージン
const TX_WRITE_LIMIT = 450;
import {AbstractEventJisshiNaiyou} from '../../shared/interfaces/abstract-event-jisshi-naiyou';
import {SaizaiSaiketsuJisshiNaiyou} from '../../shared/interfaces/saizai-saiketsu-jisshi-naiyou';
import {SafeResourceUrl} from '@angular/platform-browser';
import {ShiyoulotV2} from '../../shared/interfaces/shiyoulot';
import {TentouShoutouJikoku} from '../../shared/interfaces/tentou';
import {KeishaConfig} from '../../shared/interfaces/keisha';
import {MokuhyouTemperatureRow} from '../../shared/interfaces/mokuhyou-tempreture';
import firestore = firebase.firestore;
import {isEqual} from 'lodash-es';
import {ShiyoulotHibetsuFile} from '../../shared/interfaces/shiyoulot-hibetsu-file';
import {AngularFireFunctions} from '@angular/fire/functions';

/**
 * event取得キー
 */
interface EventSearchKey {
  year: number,
  month: number,
  fromDate: yyyyMMdd,
  toDate: yyyyMMdd,
  isMiJisshi: boolean,
  eventTaishouIds: any[]
  eventShubetsu?: EventShubetsu
  willJisshi: boolean
}

/**
 * イベント一覧のフィルター
 */
interface EventFilter {
  eventName?: string,
  eventShubetsu?: EventShubetsu,
  edukeDate?: yyyyMMdd,
  jisshiDate?: yyyyMMdd,
  touyoHouhou?: TouyoHouhous,
}

/**
 * イベント比較用
 * 1個目にチェックしたイベント内容とイベント一覧の各イベント内容を比較
 */
interface ComparisonEvent {
  id?: string,
  yoteiDate?: yyyyMMdd,
  eventShubetsu?: EventShubetsu,
  eventName?: string,
  taishouKeisha?: string,
  taishouEdukeDate?: string,
  vaccineKabu?: string,
  touyoHouhou?: TouyoHouhous, // TODO 過去データ空文字が入っている箇所有
  shubetsu?: string,
}

/**
 * カレンダー用
 */
interface CalendarDay {
  day: number,
  date: number,
  month: number,
  year: number,
  windex: number,
  dindex: number
}

/**
 * 入荷イベントの更新に併せて関連eventを更新するためのオブジェクト
 */
interface TempUpdateObjForEvent {
  yoteiDate?: yyyyMMdd,
  taishouEdukeDate?: yyyyMMdd,
}

/**
 * 入荷出荷イベントの更新に併せてshiyoulotを更新するためのオブジェクト
 */
interface TempUpdateObjForShiyoulot {
  koushinKaisuu: firestore.FieldValue,
  isExist: boolean,
  genzaiWasuu?: number,
  nyuukaWasuu?: firestore.FieldValue,
  teiseiWasuu?: firestore.FieldValue,
  allNyuukaWasuu?: firestore.FieldValue,
  nyuukaDate?: yyyyMMdd | null,
  edukeDate?: yyyyMMdd,
  dounyuuDate?: yyyyMMdd | null,
  shukkaDate?: yyyyMMdd | null,
  shukkaWasuu?: firestore.FieldValue,
  allShukkaWasuu?: firestore.FieldValue,
  isMiNyuuka?: boolean,
}

/**
 * 入荷出荷イベントの更新に併せてshiyoulotHibetsuFileを更新するためのオブジェクト
 */
interface UpdateObjForShiyoulotHibetsuFile {
  genzaiWasuu?: number,
  nyuukaWasuu?: firestore.FieldValue,
  shukkaWasuu?: firestore.FieldValue,
}

/**
 * 入荷イベントの更新に併せてkeishaHibetsuを更新するためのオブジェクト
 */
interface TempUpdateObjForKeishaHibetsu {
  feed?: Feed2,
  tentouShoutouJikoku?: TentouShoutouJikoku[],
}

/**
 * isUndoがtrueの場合は latestEdukeDate を持つが、
 * isUndoがfalseの場合は持たない。
 * @param latestEdukeDate 鶏舎餌付け日 入荷更新時のみ値が入る
 */
export type NyuukaJisshiCondDto<T extends { isUndo: boolean;}> =
  T['isUndo'] extends true
    ? T
    : T & { latestEdukeDate: yyyyMMdd };

/**
 * T['event']['eventShubetsu']では型を絞り込めないので、
 * typeというプロパティを別途指定する。
 * @param type Dtoの種別を表す
 * @param event 実施または取り消すイベント
 * @param isUndo trueの場合はイベントを取り消し、falseの場合はイベントの実施
 */
export type NyuukaJisshiReqDto = {type: 'nyuuka'; event: JisshiDateNonNullable<NyuukaEvent>; isUndo: boolean;};
export type ShukkaJisshiReqDto = {type: 'shukka'; event: JisshiDateNonNullable<ShukkaEvent>; isUndo: boolean;};

type EventDialogComponent = NyuukaEventDialogComponent | ShukkaEventDialogComponent | VaccineEventDialogComponent
  | SaizaiEventDialogComponent | SaiketsuEventDialogComponent | TaisokuEventDialogComponent
  | DebeakEventDialogComponent | OtherEventDialogComponent;

@Injectable({
  providedIn: 'root'
})
export class EventService {
  eventObservable = new Observable<WithChecked<AbstractEvent>[]>();
  subscription: Subscription = new Subscription();
  eventList: WithChecked<AbstractEvent>[] = [];
  selectedEvents: WithChecked<AbstractEvent>[] = [];
  weeks: CalendarDay[][] = [];
  eventShubetsuList = EVENT_SHUBETSU_LIST as Mutable<typeof EVENT_SHUBETSU_LIST>;
  selectedKeishas: string[] = []; // 鶏舎idの配列
  selectedEventYoteiDate = '';  // カレンダー：対象日付のイベント絞り込み用
  firstCheckedEvent: ComparisonEvent = {};
  eventFilter: EventFilter = {};
  searchKey: EventSearchKey = this.getInitialEventSearchKey();
  allEventChecked = false;

  constructor(private db: AngularFirestore,
              private sessionService: SessionService,
              private commonService: CommonService,
              private messageService: MessageService,
              private masterService: MasterService,
              private keishaHibetsuFileService: KeishaHibetsuFileService,
              private shiyoulotHibetsuFileService: ShiyoulotHibetsuFileService,
              public dialog: MatDialog
              ) { }

  /**
   *
   * @param collectionName
   */
  genCustomerRootCollectionRef(collectionName: string) : firebase.firestore.CollectionReference<firebase.firestore.DocumentData> {
    const customerId = this.sessionService.session.personalSetting.customerId;
    return this.db.firestore.collection(COLLECTION_NAME.CUSTOMERS).doc(customerId).collection(collectionName);
  }

  /**
   *
   * @param id
   */
  getEventWithId(id: string[]) {
    return this.genCustomerRootCollectionRef(COLLECTION_NAME.EVENT).where('eventTaishouIds', 'array-contains-any', id).get();
  }

  /**
   * イベント Observable 取得
   * @param kensakuKey
   */
  getEventObservable(kensakuKey: Partial<EventSearchKey>) {
    return this.genEventQuery(kensakuKey).valueChanges({idField: 'id'}) as Observable<AbstractEvent[]>;
  }

  /**
   * イベント取得
   * @param kensakuKey
   */
  getEvent(kensakuKey: Partial<EventSearchKey>) {
    return new Promise<any>(resolve => {
      const list: any = [];
      return firstValueFrom(this.genEventQuery(kensakuKey).get()).then(events => {
        events.docs.forEach(event => {
          const eventMeisai = event.data();
          eventMeisai.id = event.id;
          list.push(eventMeisai);
        });
        return resolve(list);
      });
    });
  }

  /**
   * イベント取得のためのQueryを生成
   * @param kensakuKey
   */
  genEventQuery(kensakuKey: Partial<EventSearchKey>) {
    const customerId = this.sessionService.session.personalSetting.customerId;
    return this.db.collection(COLLECTION_NAME.CUSTOMERS).doc(customerId)
      .collection(COLLECTION_NAME.EVENT, ref => {
        let query:
            | firestore.CollectionReference
            | firestore.Query = ref;
        if (kensakuKey?.fromDate) {
          query = query.where('yoteiDate', '>=', kensakuKey?.fromDate);
        }
        if (kensakuKey?.toDate) {
          query = query.where('yoteiDate', '<=', kensakuKey?.toDate);
        }
        if (kensakuKey?.eventTaishouIds) {
          query = query.where('eventTaishouIds', 'array-contains-any', kensakuKey?.eventTaishouIds);
        }
        if (kensakuKey?.eventShubetsu) {
          query = query.where('eventShubetsu', '==', kensakuKey?.eventShubetsu);
        }
        if (kensakuKey?.isMiJisshi) {
          query = query.where('jisshiDate', '==', null);
        }
        if (kensakuKey?.willJisshi) {
          query = query.where('willJisshi', '==', kensakuKey?.willJisshi);
        }
        query.orderBy('yoteiDate', 'asc');
        return query;
      });
  }

  /**
   * イベントリスト生成
   * @param kensakuKey
   */
  setEventList(kensakuKey: EventSearchKey) {
    // 新しくデータを取得する前にそれ以前にsubsribeしていたsubscriptionを初期化。
    this.subscription.unsubscribe();
    this.eventObservable = this.getEventObservable(kensakuKey);
    if (this.eventObservable) {
      this.subscription = this.eventObservable.subscribe(events => {
        // 選択イベントリストにイベントがあり、検索後イベントリストに選択済イベントと同じものがあればcheckedEventに格納
        if (this.selectedEvents.length) {
          for (let i = 0; i < this.selectedEvents.length; i++) {
            const checkedEvent = events.find((event: any) => {
              return event.id === this.selectedEvents[i].id;
            });
            // checkedEventがある場合、検索後イベントリストの対象イベントにチェック
            if (checkedEvent) {
              checkedEvent.checked = true;
            }
          }
        }
        this.eventList = events;
        console.log(events);
      });
    }
  }

  /**
   * イベント新規追加
   * @param events
   */
  setNewEvents(events: AbstractEvent[]) {
    return new Promise<void>((resolve, reject) => {
      const batch = this.db.firestore.batch();
      const customerRef = this.genCustomerRootCollectionRef(COLLECTION_NAME.EVENT);
      events.forEach(meisai => {
        const saveMeisai = {...meisai};
        if (saveMeisai.id) {
          batch.set(customerRef.doc(saveMeisai.id), saveMeisai);
        } else {
          batch.set(customerRef.doc(), saveMeisai);
        }
      });
      batch.commit().then(() => {
        this.messageService.pushInfo('作業を登録しました');
        this.resetEventChecked();
        resolve();
      }).catch(e => {
        console.log(e);
        this.messageService.pushError('作業の登録に失敗しました');
        reject();
      });
    });
  }

  // 入荷・出荷イベント以外の更新処理
  /**
   *
   * @param events
   */
  updateEvents(events: WithChecked<AbstractEvent>[]) {
    // TODO: 旧データの場合、reject、開発時にはコメントアウト
    // const kindNotExist = events.find(event => { return !event.kind; });
    // if (kindNotExist) {
    //   this.getConfirmForOldData();
    //   return Promise.reject();
    // }
    return new Promise<void>((resolve, reject) => {
      const batch = this.db.firestore.batch();
      const customerRef = this.genCustomerRootCollectionRef(COLLECTION_NAME.EVENT);
      events.forEach((meisai: WithChecked<AbstractEvent>) => {
        const saveMeisai = {...meisai};
        this.commonService.deleteUndefinedProperties(saveMeisai);
        this.commonService.deletePropertiesFromObject([saveMeisai], ['checked', 'jisshiNichirei']);
        batch.set(customerRef.doc(saveMeisai.id), saveMeisai);
      });
      batch.commit().then(() => {
        this.messageService.pushInfo('作業実施内容を更新しました');
        resolve();
      }).catch(e => {
        console.log(e);
        this.messageService.pushError('作業実施内容の更新に失敗しました');
        reject();
      });
    });
  }

  /**
   * イベント実施内容の初期化
   * (入荷・出荷以外)
   * 初期化したいプロパティが増えた際は「EVENT_JISSHI_PROPERTIES」に追加
   * @param events
   */
  undoEvents(events: AbstractEvent[]) {
    // // TODO: 旧データの場合、reject、開発時にはコメントアウト
    // const kindNotExist = events.find(event => { return !event.kind; });
    // if (kindNotExist) {
    //   this.getConfirmForOldData();
    //   return Promise.reject();
    // }
    return new Promise<void>((resolve, reject) => {
      const batch = this.db.firestore.batch();
      const customerRef = this.genCustomerRootCollectionRef(COLLECTION_NAME.EVENT);
      events.forEach((meisai: AbstractEvent) => {
        const saveMeisai = {...meisai};
        this.commonService.deleteUndefinedProperties(saveMeisai);
        this.commonService.deletePropertiesFromObject([saveMeisai], EVENT_JISSHI_PROPERTIES);
        saveMeisai.jisshiDate = null;
        batch.set(customerRef.doc(saveMeisai.id), saveMeisai);
      });
      batch.commit().then(() => {
        this.messageService.pushInfo('作業実施内容を取り消しました');
        this.resetEventChecked();
        resolve();
      }).catch(e => {
        console.log(e);
        this.messageService.pushError('作業実施内容の取り消しに失敗しました');
        reject();
      });
    });
  }

  /**
   *
   * @param events
   */
  deleteEvents(events: AbstractEvent[]) {
    // // TODO: 旧データの場合、reject、開発時にはコメントアウト
    // const kindNotExist = events.find(event => { return !event.kind; });
    // if (kindNotExist) {
    //   this.getConfirmForOldData();
    //   return Promise.reject();
    // }
    return new Promise<void>((resolve, reject) => {
      const batch = this.db.firestore.batch();
      const customerRef = this.genCustomerRootCollectionRef(COLLECTION_NAME.EVENT);
      for (const event of events) {
        if (event.jisshiDate) {
          return;
        }
        batch.delete(customerRef.doc(event.id));
      }
      batch.commit().then(() => {
        this.messageService.pushInfo('作業を削除しました');
        this.resetEventChecked();
        resolve();
      }).catch(e => {
        console.log(e);
        this.messageService.pushError('作業の削除に失敗しました');
        reject();
      });
    });
  }

  /**
   * 入荷・出荷イベント用の更新処理
   * @param dto 呼び出し時の条件に応じて適切な型のデータを渡すこと。
   *    入荷イベント実施時          NyuukaJisshiCondDto<NyuukaJisshiReqDto&{ isUndo: false }>
   *    入荷イベント取り消し時       NyuukaJisshiCondDto<NyuukaJisshiReqDto&{ isUndo: true }>
   *    出荷イベント実施・取り消し時  ShukkaJisshiReqDto
   */
  updateNyuushukkaEvent2(dto: NyuukaJisshiCondDto<NyuukaJisshiReqDto&{ isUndo: false }> | NyuukaJisshiCondDto<NyuukaJisshiReqDto&{ isUndo: true }> | ShukkaJisshiReqDto) {
    // TODO: 旧データの場合、reject、開発時にはコメントアウト
    if (!dto.event.kind) {
      this.getConfirmForOldData();
      return Promise.reject();
    }
    return new Promise<void>((resolve, reject) => {
      const saveMeisai = {...dto.event};
      // 入荷イベント更新時のみ使用。後続処理の型対応。
      this.commonService.deletePropertiesFromObject([saveMeisai], ['checked', 'jisshiNichirei']);
      const reqDto
        = dto.type === SHUKKA ? { type: (saveMeisai as JisshiDateNonNullable<ShukkaEvent>).eventShubetsu, event: saveMeisai as JisshiDateNonNullable<ShukkaEvent>, isUndo: dto.isUndo }
        : dto.isUndo ? { type: (saveMeisai as JisshiDateNonNullable<NyuukaEvent>).eventShubetsu, event: saveMeisai as JisshiDateNonNullable<NyuukaEvent>, isUndo: dto.isUndo }
        : { type: (saveMeisai as JisshiDateNonNullable<NyuukaEvent>).eventShubetsu, event: saveMeisai as JisshiDateNonNullable<NyuukaEvent>, isUndo: dto.isUndo, latestEdukeDate: dto.latestEdukeDate };
      const promise = this.switchingUpdateOrUndo2(reqDto);
      promise.then(() => {
        this.messageService.pushInfo('作業実施内容を更新しました');
        this.resetEventChecked();
        resolve();
      }).catch(e => {
        console.log(e);
        // 冪等化ガードによる業務エラー(既登録・未実施・文書なし・残数なし)は理由をそのまま表示する
        if (typeof e === 'string' && (Object.values(EVENT_GUARD_ERROR) as string[]).includes(e)) {
          this.messageService.pushError(e);
        } else {
          this.messageService.pushError('作業実施内容の更新に失敗しました');
        }
        reject();
      });
    });
  }

  /**
   * 入荷出荷イベントの更新取り消し処理を振り分け
   * @param dto
   *  event 更新対象のイベント 実施日がセットされている入荷出荷イベント。
   *  isUndo 入出荷処理を実行するか取り消すかを表す。
   *  latestEdukeDate 鶏舎餌付け日 入荷更新時のみ使用。デフォルトでevent.taishouEdukeDate
   */
  switchingUpdateOrUndo2(dto: NyuukaJisshiCondDto<NyuukaJisshiReqDto&{ isUndo: false }> | NyuukaJisshiCondDto<NyuukaJisshiReqDto&{ isUndo: true }> | ShukkaJisshiReqDto) {
    if (!dto.isUndo) {
      if (dto.type === NYUUKA) {
        return this.nyuukaEventUpdate(dto.event, dto.latestEdukeDate);
      } else {
        return this.shukkaEventUpdate(dto.event);
      }
    }
    // 日付を跨いでの入出荷取り消しは不可。
    // 入出荷モーダルの時点で当日でないと「取消」は押せないようにしているが念の為
    // if (dto.event.jisshiDate != this.commonService.getDateWithString()) {
    //   return Promise.reject('入荷・出荷は当日のみ取り消し可能です。');
    // }
    if (dto.type === NYUUKA) {
      return this.nyuukaEventUndo(dto.event);
    } else {
      return this.shukkaEventUndo(dto.event);
    }
  }

  /**
   * 飼養ロット日別ファイルのMapを生成
   * shiyoulotHibetsuFileMapは挿入順が大事(古い日付から順に挿入)
   * Map.keys()で日付を取得すると昇順になる(Map.keys()の列挙順は挿入順のため)
   * 飼養ロット日別Fの羽数更新処理では、前日の羽数を元に当日の現在羽数を算出するため、順番が大事
   *
   * @param tx
   * @param shiyoulotRef
   * @param jisshiDate
   */
  async genShiyoulotHibetsuFileMap(tx: firebase.firestore.Transaction,
                                   shiyoulotRef: firebase.firestore.DocumentReference<firebase.firestore.DocumentData>,
                                   jisshiDate: string,) {
    /** 更新する飼養ロット日別ファイルの取得 */
    const shiyoulotHibetsuFileMap: Map<string, ShiyoulotHibetsuFile | null> = new Map();
    const shiyoulotHibetsuFileDocPromiseArray = [];
    const todayString = this.commonService.getDateWithString();
    // 入荷イベント実施日から今日までの日付のdiff
    const diff = this.commonService.getDateDiff(jisshiDate, todayString);
    // 今日日付も含むため、<=
    for (let i = 0; i <= diff; i++) {
      const hibetsuDate = this.commonService.genOffsetDateWithStandardDateString(jisshiDate, i);
      // 初期値はnullをセット
      // shiyoulotHibetsuFileMapは挿入順が大事(古い日付から順に挿入)
      // Map.keys()で日付を取得すると昇順になる(Map.keys()の列挙順は挿入順のため)
      shiyoulotHibetsuFileMap.set(hibetsuDate, null);
      const shiyoulotHibetsuFileRef = shiyoulotRef.collection(COLLECTION_NAME.HIBETSUFILE).doc(hibetsuDate);
      const shiyoulotHibetsuFileDocPromise = tx.get(shiyoulotHibetsuFileRef);
      shiyoulotHibetsuFileDocPromiseArray.push(shiyoulotHibetsuFileDocPromise);
    }
    const shiyoulotHibetsuFileDocs = await Promise.all(shiyoulotHibetsuFileDocPromiseArray);

    for (const shiyoulotHibetsuFileDoc of shiyoulotHibetsuFileDocs) {
      // 飼養ロット日別ファイルがある場合、Mapに格納
      if (shiyoulotHibetsuFileDoc.exists) {
        const shiyoulotHibetsuFile = shiyoulotHibetsuFileDoc.data() as ShiyoulotHibetsuFile;
        shiyoulotHibetsuFileMap.set(shiyoulotHibetsuFile.id, shiyoulotHibetsuFile);
      }
    }

    return shiyoulotHibetsuFileMap;
  }

  /**
   * 基準日の前日の現在羽数を取得
   * 現在羽数は飼養ロット日別Fから算出
   *
   * @param shiyoulotHibetsuFileMap
   * @param date
   * @param returnZeroIfNegative
   */
  getYesterdayGenzaiWasuu(shiyoulotHibetsuFileMap: Map<string, ShiyoulotHibetsuFile | null>, date: string, returnZeroIfNegative = true) {
    const yesterday = this.commonService.genOffsetDateWithStandardDateString(date, -1);
    const yesterdayShiyoulotHibetsuFile = shiyoulotHibetsuFileMap.get(yesterday);
    // 必ずある前提
    if (yesterdayShiyoulotHibetsuFile) {
      // 出荷イベント登録時は現在羽数がマイナスを許容する
      // それ以外はマイナスは許容しない。マイナスの場合、0を返す。
      return this.commonService.calcGenzaiWasuuForShiyoulotHibetsuFile(yesterdayShiyoulotHibetsuFile, returnZeroIfNegative);
    }
    return 0;
  }

  /**
   * 入荷イベントの登録・更新
   * @param nyuukaEvent
   * @param latestEdukeDate 鶏舎config の latestEdukeDate
   */
  async nyuukaEventUpdate(nyuukaEvent: JisshiDateNonNullable<NyuukaEvent>, latestEdukeDate: yyyyMMdd) {
    try {
      console.log('nyuukaEventUpdate');
      const customerEventRef = this.genCustomerRootCollectionRef(COLLECTION_NAME.EVENT);
      // 入出荷イベントは常に一つの飼養ロットとしか紐づいていない前提
      const shiyoulotKey = nyuukaEvent.eventTaishouIds.find((val: string) => {
        return val.endsWith(SHIYOULOT_KEY_SUFFIX);
      });
      if (!shiyoulotKey) { throw new Error('イベントに飼養ロットが登録されていません。'); }
      const shiyoulotId = shiyoulotKey ? shiyoulotKey.slice(0, -2) : '';
      const shiyoulotRef = this.genCustomerRootCollectionRef(COLLECTION_NAME.SHIYOULOT).doc(shiyoulotId);
      const shiyoulotHibetsuFileCollectionRef = shiyoulotRef.collection(COLLECTION_NAME.HIBETSUFILE);
      const todayString = this.commonService.getDateWithString();

      // @ts-ignore
      await this.db.firestore.runTransaction(async(tx) => {

        /** 冪等化ガード */
        // 保存済みイベントをトランザクション内で最初に読み、実施済みなら中断する(二重登録防止)。
        // 判定は画面から渡された値ではなく保存済み文書を正とする。
        // 同時実行時もコミット競合の再試行で保存済み状態を再読取するため、2回目は必ず拒否される。
        const eventDoc = await tx.get(customerEventRef.doc(nyuukaEvent.id));
        if (!eventDoc.exists) { return Promise.reject(EVENT_GUARD_ERROR.EVENT_NOT_FOUND); }
        const savedNyuukaEvent = eventDoc.data() as NyuukaEvent;
        if (savedNyuukaEvent.jisshiDate) { return Promise.reject(EVENT_GUARD_ERROR.ALREADY_REGISTERED); }

        /** 入荷羽数の値域ガード */
        // 羽数は小数を取り得ないため、整数以外は書き込む前に中断する。
        // 画面側のバリデーションは旧タブや値の貼り付けで回避されうるため、書込直前でも検証する。
        // 小数が入ると現在羽数の連鎖が破綻し、日次バッチが日別ファイルの生成を停止する。
        if (!Number.isInteger(nyuukaEvent.nyuukaWasuu) || Number(nyuukaEvent.nyuukaWasuu) < 1) {
          return Promise.reject(EVENT_GUARD_ERROR.INVALID_NYUUKA_WASUU);
        }

        /** 更新する飼養ロット日別ファイルの取得 */
        // 飼養ロット日別ファイルのMap。key: 日付, value: 飼養ロット日別ファイル。初期値はnull
        // shiyoulotHibetsuFileMapは挿入順が大事(古い日付から順に挿入)
        // Map.keys()で日付を取得すると昇順になる(Map.keys()の列挙順は挿入順のため)
        const shiyoulotHibetsuFileMap = await this.genShiyoulotHibetsuFileMap(tx, shiyoulotRef, nyuukaEvent.jisshiDate);

        const doc = await tx.get(shiyoulotRef);
        /** 鶏舎日別ファイルの取得 */
        // トランザクションの読み取りは全書き込みより前に行う必要があるため、ここで読む
        const keishaRef = this.genCustomerRootCollectionRef(COLLECTION_NAME.KEISHAMASTER)
          .doc(nyuukaEvent.taishouKeisha);
        const keishaHibetsuFileDoc = await tx.get(keishaRef.collection(COLLECTION_NAME.KEISHAHIBETSUFILE)
          .doc(nyuukaEvent.jisshiDate));
        if (doc.exists) {
          const shiyoulotDoc = doc.data() as ShiyoulotV2;
          if (!shiyoulotDoc) {
            return Promise.reject('ドキュメントが見つかりません');
          }
          const nyuukaWasuu = nyuukaEvent.nyuukaWasuu ? nyuukaEvent.nyuukaWasuu : 0;

          /** 飼養ロット日別ファイルの更新 */
          for (const date of shiyoulotHibetsuFileMap.keys()) {
            const shiyoulotHibetsuFile = shiyoulotHibetsuFileMap.get(date);
            // 飼養ロット日別ファイルがある場合
            if (shiyoulotHibetsuFile) {
              let updateObjForShiyoulotHibetsuFile: UpdateObjForShiyoulotHibetsuFile = {};
              if (shiyoulotHibetsuFile.id === nyuukaEvent.jisshiDate) {
                // 飼養ロット日別Fが入荷イベント実施日の場合
                updateObjForShiyoulotHibetsuFile.nyuukaWasuu = firebase.firestore.FieldValue.increment(nyuukaWasuu);
                // 入荷羽数を加算して、Mapにセット
                shiyoulotHibetsuFile.nyuukaWasuu += nyuukaWasuu;
              } else {
                // 飼養ロット日別Fが入荷イベント実施日以外の場合
                const yesterdayGenzaiWasuu = this.getYesterdayGenzaiWasuu(shiyoulotHibetsuFileMap, date);
                updateObjForShiyoulotHibetsuFile.genzaiWasuu = yesterdayGenzaiWasuu;
                shiyoulotHibetsuFile.genzaiWasuu = yesterdayGenzaiWasuu;
              }
              // Mapにセット、更新
              shiyoulotHibetsuFileMap.set(date, shiyoulotHibetsuFile);
              tx.update(shiyoulotHibetsuFileCollectionRef.doc(date), updateObjForShiyoulotHibetsuFile);
            } else {
              // 飼養ロット日別Fがない場合
              const newShiyoulotHibetsuFile = this.shiyoulotHibetsuFileService.getInitialShiyolotHibetsuFile(shiyoulotId, nyuukaEvent.taishouKeisha, date);
              if (date === nyuukaEvent.jisshiDate) {
                // 飼養ロット日別Fが入荷イベント実施日の場合
                newShiyoulotHibetsuFile.nyuukaWasuu = nyuukaWasuu;
              } else {
                // 飼養ロット日別Fが入荷イベント実施日以外の場合
                const yesterdayGenzaiWasuu = this.getYesterdayGenzaiWasuu(shiyoulotHibetsuFileMap, date);
                newShiyoulotHibetsuFile.genzaiWasuu = yesterdayGenzaiWasuu;
              }
              // Mapにセット、新規登録
              shiyoulotHibetsuFileMap.set(date, newShiyoulotHibetsuFile);
              tx.set(shiyoulotHibetsuFileCollectionRef.doc(date), newShiyoulotHibetsuFile);
            }
          }
          console.log(shiyoulotHibetsuFileMap);

          /** 飼養ロット更新 **/
          const tempUpdateObjForShiyoulot: TempUpdateObjForShiyoulot = {
            allNyuukaWasuu: firebase.firestore.FieldValue.increment(nyuukaWasuu),
            koushinKaisuu: firebase.firestore.FieldValue.increment(1),
            isExist: true,
            isMiNyuuka: false,
          };
          if (nyuukaEvent.jisshiDate === todayString) {
            // 当日の場合、入荷羽数を加算
            tempUpdateObjForShiyoulot.nyuukaWasuu = firebase.firestore.FieldValue.increment(nyuukaWasuu);
          } else {
            // 今日日付以外の場合、今日の飼養ロット日別ファイルの現在羽数をセット
            const todayShiyoulotHibetsuFile = shiyoulotHibetsuFileMap.get(todayString);
            tempUpdateObjForShiyoulot.genzaiWasuu = todayShiyoulotHibetsuFile?.genzaiWasuu ?? 0;
          }
          tx.update(shiyoulotRef, tempUpdateObjForShiyoulot);

          /** 入荷イベント更新 **/
          tx.set(customerEventRef.doc(nyuukaEvent.id), nyuukaEvent, {merge: true});

          /** 鶏舎configファイルの更新 */
          const keishaConfigRef = this.genKeishaConfigRef(nyuukaEvent.taishouKeisha);
          // keishaConfigを更新
          tx.set(keishaConfigRef, {latestEdukeDate}, {merge: true});

          /** 鶏舎日別ファイルの更新 */
          if (keishaHibetsuFileDoc.exists) {
            const tempUpdateObjForKeishaHibetsu: TempUpdateObjForKeishaHibetsu = {};
            tempUpdateObjForKeishaHibetsu.feed = this.getFeed2(nyuukaEvent);
            tempUpdateObjForKeishaHibetsu.tentouShoutouJikoku = this.getTentou(nyuukaEvent.taishouKeisha, latestEdukeDate, nyuukaEvent.jisshiDate);

            tx.update(keishaHibetsuFileDoc.ref, tempUpdateObjForKeishaHibetsu);
          } else {
            const keishaHibetsu = this.keishaHibetsuFileService.getInitKeishaHibetsuFile(nyuukaEvent.taishouKeisha, nyuukaEvent.jisshiDate);
            keishaHibetsu.feed = this.getFeed2(nyuukaEvent);
            keishaHibetsu.tentouShoutouJikoku = this.getTentou(nyuukaEvent.taishouKeisha, latestEdukeDate, nyuukaEvent.jisshiDate);
            tx.set(keishaHibetsuFileDoc.ref, keishaHibetsu, {merge: true});
          }

        } else {
          return Promise.reject('ドキュメントが見つかりません。');
        }
      });

      return Promise.resolve();

    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  }

  /**
   * 出荷イベントの登録・更新
   * @param shukkaEvent
   */
  async shukkaEventUpdate(shukkaEvent: JisshiDateNonNullable<ShukkaEvent>) {
    console.log('shukkaEventUpdate');
    const customerEventRef = this.genCustomerRootCollectionRef(COLLECTION_NAME.EVENT);
    // 入出荷イベントは常に一つの飼養ロットとしか紐づいていない前提
    const shiyoulotKey = shukkaEvent.eventTaishouIds.find((val: string) => {
      return val.endsWith(SHIYOULOT_KEY_SUFFIX);
    });
    if (!shiyoulotKey) { throw new Error('イベントに飼養ロットが登録されていません。'); }
    const shiyoulotId = shiyoulotKey ? shiyoulotKey.slice(0, -2) : '';
    const shiyoulotRef = this.genCustomerRootCollectionRef(COLLECTION_NAME.SHIYOULOT).doc(shiyoulotId);
    const shiyoulotHibetsuFileCollectionRef = shiyoulotRef.collection(COLLECTION_NAME.HIBETSUFILE);
    const todayString = this.commonService.getDateWithString();

    try {
      // 飼養ロットに紐づく未実施イベント全件取得
      const batch = this.db.firestore.batch();
      const eventKensakuKey: Partial<EventSearchKey> = {
        eventTaishouIds: [shiyoulotKey],
        willJisshi: true,
        isMiJisshi: true
      }
      const mijisshiEventList = (await this.getEvent(eventKensakuKey)) as EventForEdit<AbstractEvent>[];

      // @ts-ignore
      await this.db.firestore.runTransaction(async(tx) => {
        /** 冪等化ガード */
        // 保存済みイベントをトランザクション内で最初に読み、実施済みなら中断する(二重登録防止)。
        // 判定は画面から渡された値ではなく保存済み文書を正とする。
        // オールアウト(idなし・毎回新規イベントを生成する)はイベント文書で判定できないため、
        // 後段のロット状態(現在羽数)で判定する。
        if (shukkaEvent.eventName !== SHUKKA_EVENT_NAME.ALL_OUT) {
          if (!shukkaEvent.id) { return Promise.reject(EVENT_GUARD_ERROR.EVENT_NOT_FOUND); }
          const eventDoc = await tx.get(customerEventRef.doc(shukkaEvent.id));
          if (!eventDoc.exists) { return Promise.reject(EVENT_GUARD_ERROR.EVENT_NOT_FOUND); }
          const savedShukkaEvent = eventDoc.data() as ShukkaEvent;
          if (savedShukkaEvent.jisshiDate) { return Promise.reject(EVENT_GUARD_ERROR.ALREADY_REGISTERED); }
        }

        /** 更新する飼養ロット日別ファイルの取得 */
        // 飼養ロット日別ファイルのMap。key: 日付, value: 飼養ロット日別ファイル。初期値はnull
        // shiyoulotHibetsuFileMapは挿入順が大事(古い日付から順に挿入)
        // Map.keys()で日付を取得すると昇順になる(Map.keys()の列挙順は挿入順のため)
        const shiyoulotHibetsuFileMap = await this.genShiyoulotHibetsuFileMap(tx, shiyoulotRef, shukkaEvent.jisshiDate);

        const shiyoulotDoc = await tx.get(shiyoulotRef);
        if (shiyoulotDoc.exists) {
          const beforeModifiedShiyoulot = shiyoulotDoc.data();
          if (!beforeModifiedShiyoulot) { return Promise.reject('ドキュメントが見つかりません'); }
          let isExist = true;
          const genzaiWasuu = this.commonService.calcGenzaiWasuuForShiyoulotFile(beforeModifiedShiyoulot);
          // 現在処理中の出荷イベント以外に未実施の出荷イベントが一つも無い
          const isAllOut = shukkaEvent.eventName === SHUKKA_EVENT_NAME.ALL_OUT;
          // オールアウトの二重実行防止: 現在羽数が既に0なら中断する
          if (isAllOut && genzaiWasuu <= 0) { return Promise.reject(EVENT_GUARD_ERROR.NO_GENZAI_WASUU); }
          // オールアウトの場合、現在羽数(残雛)を全て出荷。
          shukkaEvent.shukkaWasuu = isAllOut ? genzaiWasuu : shukkaEvent.shukkaWasuu;
          const shukkaWasuu = shukkaEvent.shukkaWasuu ?? 0;

          /** 出荷羽数の値域ガード */
          // 羽数は小数を取り得ないため、整数以外は書き込む前に中断する。
          // 画面側のバリデーションは旧タブや値の貼り付けで回避されうるため、書込直前でも検証する。
          // オールアウトは現在羽数をそのまま出荷するため、現在羽数が小数のロットも本ガードで弾ける。
          if (!Number.isInteger(shukkaWasuu) || shukkaWasuu < 1) {
            return Promise.reject(EVENT_GUARD_ERROR.INVALID_SHUKKA_WASUU);
          }
          // 残羽数が0未満、「isExist」をfalseに更新。
          if (genzaiWasuu <= shukkaWasuu || isAllOut) {
            isExist = false;
            console.log('isExist:', isExist, 'genzaiWasuu:', genzaiWasuu, 'event.shukkaWasuu:', shukkaEvent.shukkaWasuu);

            /** 未実施イベントの実施日を更新 */
            // 実施日 '9999-12-31' をセット
            // 出荷イベント以外のイベントを更新する。
            // 複数出荷の場合、今後出荷予定の出荷イベントが更新されないようにするため
            const mijisshiTargets = mijisshiEventList.filter(ev => ev.eventShubetsu !== "shukka" || isAllOut);
            // トランザクション成功後にバッチだけ失敗すると、冪等化ガードが再実行を拒否して回復できないため、
            // 書き込み件数が上限に収まる場合は同一トランザクションで更新する。
            // 対象文書はトランザクション内で再読取し(鮮度・競合検出の確保)、削除済みの文書は除外する。
            const totalWrites = shiyoulotHibetsuFileMap.size + 2 + mijisshiTargets.length; // 日別+ロット+イベント+未実施イベント
            if (totalWrites <= TX_WRITE_LIMIT) {
              const mijisshiDocs = await Promise.all(mijisshiTargets.map(ev => tx.get(customerEventRef.doc(ev.id))));
              mijisshiDocs.filter(mijisshiDoc => mijisshiDoc.exists)
                .forEach(mijisshiDoc => tx.update(mijisshiDoc.ref, {jisshiDate: DEFAULT_JISSHIDATE}));
            } else {
              // 上限超過時は従来どおり後続バッチで更新する(バッチのみ失敗した場合は手動回復が必要)
              mijisshiTargets.forEach(ev => batch.update(customerEventRef.doc(ev.id), {jisshiDate: DEFAULT_JISSHIDATE}));
            }
          }

          /** 飼養ロット日別ファイルの更新 */
          for (const date of shiyoulotHibetsuFileMap.keys()) {
            const shiyoulotHibetsuFile = shiyoulotHibetsuFileMap.get(date);
            // 飼養ロット日別Fがある場合
            // 飼養ロット日別Fがないのはありえない。(出荷実施日は入荷日以降で、入荷があれば、飼養ロット日別Fは存在する。)
            if (shiyoulotHibetsuFile) {
              const shiyoulotHibetsuFileRef = shiyoulotHibetsuFileCollectionRef.doc(shiyoulotHibetsuFile.id)
              let updateObjForShiyoulotHibetsuFile: UpdateObjForShiyoulotHibetsuFile = {};
              if (shiyoulotHibetsuFile.id === shukkaEvent.jisshiDate) {
                // 飼養ロット日別Fが出荷イベント実施日の場合
                updateObjForShiyoulotHibetsuFile.shukkaWasuu = firebase.firestore.FieldValue.increment(shukkaWasuu);
                // 出荷羽数を加算して、Mapにセット
                shiyoulotHibetsuFile.shukkaWasuu += shukkaWasuu;
              } else {
                // 飼養ロット日別Fが出荷イベント実施日以外の場合
                // 昨日の現在羽数を取得。出荷イベント登録時は現在羽数がマイナスを許容する
                const yesterdayGenzaiWasuu = this.getYesterdayGenzaiWasuu(shiyoulotHibetsuFileMap, date, false);
                // 昨日の現在羽数が0未満かどうかチェック
                if (yesterdayGenzaiWasuu < 0) {
                  return Promise.reject(date + '：　現在羽数が0未満です。');
                }
                updateObjForShiyoulotHibetsuFile.genzaiWasuu = yesterdayGenzaiWasuu;
                shiyoulotHibetsuFile.genzaiWasuu = yesterdayGenzaiWasuu;
              }
              // Mapにセット、更新
              shiyoulotHibetsuFileMap.set(date, shiyoulotHibetsuFile);
              tx.update(shiyoulotHibetsuFileRef, updateObjForShiyoulotHibetsuFile);
            }
          }

          /** 出荷イベント、飼養ロットの更新 */
          const shiyoulotUpdateObj: TempUpdateObjForShiyoulot = {
            allShukkaWasuu: firebase.firestore.FieldValue.increment(shukkaWasuu),
            isExist,
            koushinKaisuu: firebase.firestore.FieldValue.increment(1),
          };
          if (shukkaEvent.jisshiDate === todayString) {
            // 今日日付の場合、出荷羽数を加算
            shiyoulotUpdateObj.shukkaWasuu = firebase.firestore.FieldValue.increment(shukkaWasuu);
          } else {
            // 今日日付以外の場合、今日の飼養ロット日別ファイルの現在羽数をセット
            const todayShiyoulotHibetsuFile = shiyoulotHibetsuFileMap.get(todayString);
            shiyoulotUpdateObj.genzaiWasuu = todayShiyoulotHibetsuFile?.genzaiWasuu ?? 0;
          }
          tx.update(shiyoulotRef, shiyoulotUpdateObj);
          tx.set(customerEventRef.doc(shukkaEvent.id), shukkaEvent);

        } else {
          return Promise.reject('ドキュメントが見つかりません。');
        }
      }).then(() => batch.commit());

      return Promise.resolve();
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  }

  /**
   * 入荷イベントの取り消し
   * @param nyuukaEvent
   */
  async nyuukaEventUndo(nyuukaEvent: JisshiDateNonNullable<NyuukaEvent>) {
    try {
      console.log('nyuukaEventUndo');
      const customerEventRef = this.genCustomerRootCollectionRef(COLLECTION_NAME.EVENT);
      // 実施日はトランザクション内で保存済みイベントの値に置き換える
      let tempJisshiDate = nyuukaEvent.jisshiDate;
      const updateNyuukaEvent: NyuukaEvent = Object.assign({}, nyuukaEvent);
      this.commonService.deletePropertiesFromObject([updateNyuukaEvent], EVENT_JISSHI_PROPERTIES);
      updateNyuukaEvent.jisshiDate = null;
      const shiyoulotKey = nyuukaEvent.eventTaishouIds.find((val: string) => {
        return val.endsWith(SHIYOULOT_KEY_SUFFIX);
      });
      if (!shiyoulotKey) { throw new Error('イベントに飼養ロットが登録されていません。'); }
      const shiyoulotId = shiyoulotKey ? shiyoulotKey.slice(0, -2) : '';
      const shiyoulotRef = this.genCustomerRootCollectionRef(COLLECTION_NAME.SHIYOULOT).doc(shiyoulotId);
      const shiyoulotHibetsuFileCollectionRef = shiyoulotRef.collection(COLLECTION_NAME.HIBETSUFILE);
      // 減算羽数はトランザクション内で保存済みイベントの値に置き換える
      let nyuukaWasuu = updateNyuukaEvent.nyuukaWasuu ? updateNyuukaEvent.nyuukaWasuu : 0;
      const todayString = this.commonService.getDateWithString();
      // @ts-ignore
      await this.db.firestore.runTransaction(async(tx) => {
        /** 冪等化ガード */
        // 保存済みイベントをトランザクション内で最初に読み、未実施なら中断する(二重取り消しによる過剰減算の防止)。
        // 減算羽数・実施日は画面から渡された値ではなく保存済み文書を正とする。
        const eventDoc = await tx.get(customerEventRef.doc(nyuukaEvent.id));
        if (!eventDoc.exists) { return Promise.reject(EVENT_GUARD_ERROR.EVENT_NOT_FOUND); }
        const savedNyuukaEvent = eventDoc.data() as NyuukaEvent;
        if (!savedNyuukaEvent.jisshiDate) { return Promise.reject(EVENT_GUARD_ERROR.NOT_REGISTERED); }
        tempJisshiDate = savedNyuukaEvent.jisshiDate;
        nyuukaWasuu = savedNyuukaEvent.nyuukaWasuu ? savedNyuukaEvent.nyuukaWasuu : 0;

        /** 更新する飼養ロット日別ファイルの取得 */
        // 飼養ロット日別ファイルのMap。key: 日付, value: 飼養ロット日別ファイル。初期値はnull
        // shiyoulotHibetsuFileMapは挿入順が大事(古い日付から順に挿入)
        // Map.keys()で日付を取得すると昇順になる(Map.keys()の列挙順は挿入順のため)
        const shiyoulotHibetsuFileMap = await this.genShiyoulotHibetsuFileMap(tx, shiyoulotRef, tempJisshiDate);

        // 飼養ロットの更新
        const doc = await tx.get(shiyoulotRef);
        if (doc.exists) {
          const shiyoulotDoc = doc.data() as ShiyoulotV2;
          if (!shiyoulotDoc) { return Promise.reject('ドキュメントが見つかりません'); }

          /** 飼養ロット日別ファイルの更新 */
          for (const date of shiyoulotHibetsuFileMap.keys()) {
            const shiyoulotHibetsuFile = shiyoulotHibetsuFileMap.get(date);
            // 飼養ロット日別Fがある場合
            // 飼養ロット日別Fがないのはありえない。(入荷があれば、飼養ロット日別Fは存在する。)
            if (shiyoulotHibetsuFile) {
              const shiyoulotHibetsuFileRef = shiyoulotHibetsuFileCollectionRef.doc(shiyoulotHibetsuFile.id)
              let updateObjForShiyoulotHibetsuFile: UpdateObjForShiyoulotHibetsuFile = {};
              if (shiyoulotHibetsuFile.id === tempJisshiDate) {
                // 飼養ロット日別Fが入荷イベント実施日の場合
                // 入荷羽数を減算
                updateObjForShiyoulotHibetsuFile = {nyuukaWasuu: firebase.firestore.FieldValue.increment(-nyuukaWasuu)};
                // 出荷羽数を加算して、Mapにセット
                shiyoulotHibetsuFile.nyuukaWasuu -= nyuukaWasuu;
              } else {
                // 飼養ロット日別Fが出荷イベント実施日以外の場合
                const yesterdayGenzaiWasuu = this.getYesterdayGenzaiWasuu(shiyoulotHibetsuFileMap, date);
                updateObjForShiyoulotHibetsuFile.genzaiWasuu = yesterdayGenzaiWasuu;
                shiyoulotHibetsuFile.genzaiWasuu = yesterdayGenzaiWasuu;
              }
              // Mapにセット、更新
              shiyoulotHibetsuFileMap.set(date, shiyoulotHibetsuFile);
              tx.update(shiyoulotHibetsuFileRef, updateObjForShiyoulotHibetsuFile);
            }
          }

          /** 飼養ロットの更新 */
          const genzaiWasuu = this.commonService.calcGenzaiWasuuForShiyoulotFile(shiyoulotDoc);
          const tempUpdateObjForShiyoulot: TempUpdateObjForShiyoulot = {
            allNyuukaWasuu: firebase.firestore.FieldValue.increment(-nyuukaWasuu),
            isExist: genzaiWasuu > nyuukaWasuu,
            isMiNyuuka: shiyoulotDoc.allNyuukaWasuu - nyuukaWasuu < 1,
            koushinKaisuu: firebase.firestore.FieldValue.increment(1),
          };
          if (tempJisshiDate === todayString) {
            tempUpdateObjForShiyoulot.nyuukaWasuu = firebase.firestore.FieldValue.increment(-nyuukaWasuu);
          } else {
            // 今日日付以外の場合、今日の飼養ロット日別ファイルの現在羽数をセット
            const todayShiyoulotHibetsuFile = shiyoulotHibetsuFileMap.get(todayString);
            tempUpdateObjForShiyoulot.genzaiWasuu = todayShiyoulotHibetsuFile?.genzaiWasuu ?? 0;
          }
          tx.update(shiyoulotRef, tempUpdateObjForShiyoulot);

          /** 入荷イベントの更新 */
          // 入荷羽数を空にしてイベントを更新。
          delete updateNyuukaEvent.nyuukaWasuu;
          tx.set(customerEventRef.doc(updateNyuukaEvent.id), updateNyuukaEvent);
        } else {
          return Promise.reject('ドキュメントが見つかりません。');
        }
      });

      return Promise.resolve();
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  }

  /**
   * 出荷イベントの取り消し
   * @param shukkaEvent
   */
  async shukkaEventUndo(shukkaEvent: JisshiDateNonNullable<ShukkaEvent>) {
    try {
      console.log('shukkaEventUndo');
      const customerEventRef = this.genCustomerRootCollectionRef(COLLECTION_NAME.EVENT);
      // 実施日はトランザクション内で保存済みイベントの値に置き換える
      let tempJisshiDate = shukkaEvent.jisshiDate;
      const updateShukkaEvent: ShukkaEvent = Object.assign({}, shukkaEvent);
      this.commonService.deletePropertiesFromObject([updateShukkaEvent], EVENT_JISSHI_PROPERTIES);
      updateShukkaEvent.jisshiDate = null;
      const shiyoulotKey = updateShukkaEvent.eventTaishouIds.find((val: string) => {
        return val.endsWith(SHIYOULOT_KEY_SUFFIX);
      });
      if (!shiyoulotKey) { throw new Error('イベントに飼養ロットが登録されていません。'); }
      const shiyoulotId = shiyoulotKey ? shiyoulotKey.slice(0, -2) : '';
      const shiyoulotRef = this.genCustomerRootCollectionRef(COLLECTION_NAME.SHIYOULOT).doc(shiyoulotId);
      const shiyoulotHibetsuFileCollectionRef = shiyoulotRef.collection(COLLECTION_NAME.HIBETSUFILE);
      const todayString = this.commonService.getDateWithString();
      const batch = this.db.firestore.batch();
      // 減算羽数はトランザクション内で保存済みイベントの値に置き換える
      let shukkaWasuu = updateShukkaEvent.shukkaWasuu ?? 0;
      // 実施日'9999-12-31'の復元候補(飼養ロットに紐づくイベント)を事前取得
      const eventKensakuKey: Partial<EventSearchKey> = {
        eventTaishouIds: [shiyoulotKey],
        willJisshi: true
      }
      const eventList = (await this.getEvent(eventKensakuKey)) as EventForEdit<AbstractEvent>[];
      const fukugenKouho = eventList.filter(ev => ev.jisshiDate === DEFAULT_JISSHIDATE);

      // @ts-ignore
      await this.db.firestore.runTransaction(async(tx) => {
        /** 冪等化ガード */
        // 保存済みイベントをトランザクション内で最初に読み、未実施なら中断する(二重取り消しによる過剰減算の防止)。
        // 減算羽数・実施日は画面から渡された値ではなく保存済み文書を正とする。
        const eventDoc = await tx.get(customerEventRef.doc(shukkaEvent.id));
        if (!eventDoc.exists) { return Promise.reject(EVENT_GUARD_ERROR.EVENT_NOT_FOUND); }
        const savedShukkaEvent = eventDoc.data() as ShukkaEvent;
        if (!savedShukkaEvent.jisshiDate) { return Promise.reject(EVENT_GUARD_ERROR.NOT_REGISTERED); }
        tempJisshiDate = savedShukkaEvent.jisshiDate;
        shukkaWasuu = savedShukkaEvent.shukkaWasuu ?? 0;

        /** 更新する飼養ロット日別ファイルの取得 */
        // 飼養ロット日別ファイルのMap。key: 日付, value: 飼養ロット日別ファイル。初期値はnull
        // shiyoulotHibetsuFileMapは挿入順が大事(古い日付から順に挿入)
        // Map.keys()で日付を取得すると昇順になる(Map.keys()の列挙順は挿入順のため)
        const shiyoulotHibetsuFileMap = await this.genShiyoulotHibetsuFileMap(tx, shiyoulotRef, tempJisshiDate);

        const shiyoulotDoc = await tx.get(shiyoulotRef);
        /** 復元対象イベントの再読取 */
        // トランザクション成功後にバッチだけ失敗すると、冪等化ガードが再実行を拒否して回復できないため、
        // 書き込み件数が上限に収まる場合は同一トランザクションで復元する。
        // 対象文書はトランザクション内で再読取し(鮮度・競合検出の確保)、読み取りは全書き込みより前に行う。
        const totalWrites = shiyoulotHibetsuFileMap.size + 2 + fukugenKouho.length; // 日別+ロット+イベント+復元対象
        const fukugenDocs = totalWrites <= TX_WRITE_LIMIT
          ? await Promise.all(fukugenKouho.map(ev => tx.get(customerEventRef.doc(ev.id))))
          : [];
        if (shiyoulotDoc.exists) {
          const beforeModifiedShiyoulot = shiyoulotDoc.data();
          if (!beforeModifiedShiyoulot) { return Promise.reject('ドキュメントが見つかりません'); }

          /** 飼養ロット日別ファイルの更新 */
          for (const date of shiyoulotHibetsuFileMap.keys()) {
            const shiyoulotHibetsuFile = shiyoulotHibetsuFileMap.get(date);
            // 飼養ロット日別Fがある場合
            if (shiyoulotHibetsuFile) {
              // const shiyoulotHibetsuFileRef = shiyoulotHibetsuFileCollectionRef.doc(shiyoulotHibetsuFile.id)
              let updateObjForShiyoulotHibetsuFile: UpdateObjForShiyoulotHibetsuFile = {};

              if (shiyoulotHibetsuFile.id === tempJisshiDate) {
                // 飼養ロット日別Fが出荷イベント実施日の場合
                updateObjForShiyoulotHibetsuFile.shukkaWasuu = firebase.firestore.FieldValue.increment(-shukkaWasuu);
                // 出荷羽数を減算
                shiyoulotHibetsuFile.shukkaWasuu -= shukkaWasuu;
              } else {
                // 飼養ロット日別Fが出荷イベント実施日以外の場合
                const yesterdayGenzaiWasuu = this.getYesterdayGenzaiWasuu(shiyoulotHibetsuFileMap, date);
                updateObjForShiyoulotHibetsuFile.genzaiWasuu = yesterdayGenzaiWasuu;
                shiyoulotHibetsuFile.genzaiWasuu = yesterdayGenzaiWasuu;
              }

              // Mapにセットし、更新
              shiyoulotHibetsuFileMap.set(date, shiyoulotHibetsuFile);
              tx.update(shiyoulotHibetsuFileCollectionRef.doc(date), updateObjForShiyoulotHibetsuFile);

            } else {
              // 飼養ロット日別Fがない場合
              const newShiyoulotHibetsuFile = this.shiyoulotHibetsuFileService.getInitialShiyolotHibetsuFile(shiyoulotId, shukkaEvent.taishouKeisha, date);

              // 飼養ロット日別Fが出荷イベント実施日の場合、飼養ロット日別Fがないことはありえない。
              if (date !== tempJisshiDate) {
                // 飼養ロット日別Fが出荷イベント実施日以外の場合
                const yesterdayGenzaiWasuu = this.getYesterdayGenzaiWasuu(shiyoulotHibetsuFileMap, date);
                newShiyoulotHibetsuFile.genzaiWasuu = yesterdayGenzaiWasuu;
              }
              // Mapにセット、新規登録
              shiyoulotHibetsuFileMap.set(date, newShiyoulotHibetsuFile);
              tx.set(shiyoulotHibetsuFileCollectionRef.doc(date), newShiyoulotHibetsuFile);
            }
          }

          /** 飼養ロットの更新 */
          const tempUpdateObjForShiyoulot: TempUpdateObjForShiyoulot = {
            allShukkaWasuu: firebase.firestore.FieldValue.increment(-shukkaWasuu),
            isExist: true,
            isMiNyuuka: false,
            koushinKaisuu: firebase.firestore.FieldValue.increment(1),
          };
          if (tempJisshiDate === todayString) {
            // 当日の出荷イベントが取り消された場合、出荷羽数を減算
            tempUpdateObjForShiyoulot.shukkaWasuu = firebase.firestore.FieldValue.increment(-shukkaWasuu);
          } else {
            // 今日日付以外の場合、今日の飼養ロット日別ファイルの現在羽数をセット
            const todayShiyoulotHibetsuFile = shiyoulotHibetsuFileMap.get(todayString);
            tempUpdateObjForShiyoulot.genzaiWasuu = todayShiyoulotHibetsuFile?.genzaiWasuu ?? 0;
          }
          tx.update(shiyoulotRef, tempUpdateObjForShiyoulot);

          /** 飼養ロットに紐づくイベントで実施日：'9999-12-31' にしたイベントを元に戻す */
          // 未実施イベントに実施日 null をセット
          if (totalWrites <= TX_WRITE_LIMIT) {
            fukugenDocs
              .filter(fukugenDoc => fukugenDoc.exists && (fukugenDoc.data() as AbstractEvent).jisshiDate === DEFAULT_JISSHIDATE)
              .forEach(fukugenDoc => tx.update(fukugenDoc.ref, {jisshiDate: null}));
          } else {
            // 上限超過時は従来どおり後続バッチで更新する(バッチのみ失敗した場合は再登録→再取り消しで回復可能)
            fukugenKouho.forEach(ev => batch.update(customerEventRef.doc(ev.id), {jisshiDate: null}));
          }

          /** 出荷イベントの更新 */
          // 出荷羽数を空にしてイベントを更新。
          delete updateShukkaEvent.shukkaWasuu;
          tx.set(customerEventRef.doc(updateShukkaEvent.id), updateShukkaEvent);

        } else {
          return Promise.reject('ドキュメントが見つかりません。');
        }

      }).then(() => batch.commit());

      return Promise.resolve();
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  }

  /**
   * 旧データが入力された場合、confirm表示
   */
  getConfirmForOldData() {
    const result = confirm('第一期開発時点のデータはこちらから更新してください。\n'
      + 'https://farm-manager-prototype.web.app/event/list\n\n'
      + '遷移しますか？\n');
    if (result) { open('https://farm-manager-prototype.web.app/event/list'); }
  }

  /**
   *
   * @param keisha
   * @param tx
   */
  async getKeishaConfig(keisha: string) {
    const keishaConfigDoc = await this.genKeishaConfigRef(keisha).get();
    if (keishaConfigDoc.exists) {
      return keishaConfigDoc.data() as KeishaConfig;
    }
    return null;
  }

  /**
   * 入荷時に呼ばれる。入荷対象鶏舎の0番目の餌をセット
   * Feed2型 を返す。(切り替え日齢なし)
   * @param event
   * @private
   */
  private getFeed2(event: NyuukaEvent): Feed2 {
    const farmId = this.commonService.getName(this.masterService.keishaMaster, event.taishouKeisha, 'farmId');
    const farm = this.masterService.farmMaster.find(farm => {
      return farm.id === farmId;
    });

    let result: Feed = genFeedDefaultValue();
    if (farm && farm.feedIdList && farm.feedIdList[0]) {
      const tempFeed = this.masterService.feedMaster[0].feedProgram.find(feed => farm.feedIdList[0] === feed.id);
      if (tempFeed) { result = tempFeed;}
    } else if (farm && farm.feedList && farm.feedList[0]) {
      result = farm.feedList[0];
    }
    if (result.kirikaeNichirei) {
      delete result.kirikaeNichirei;
    }
    return result;
  }

  /**
   *
   * @param keisha
   * @param edukeDate
   * @param hikakuDate
   */
  private getTentou(keisha: string, edukeDate: string, hikakuDate: string = this.commonService.getDateWithString()) {
    const tentouProgramId = this.commonService.getName(this.masterService.keishaMaster, keisha, 'tentouProgramId');
    const tentouProgramDoc = this.masterService.tentouMaster.find(tentouProgram => {
      return tentouProgram.id === tentouProgramId;
    });
    if (tentouProgramDoc && tentouProgramDoc.tentouProgram && tentouProgramDoc.tentouProgram.length) {
      const genzaiNichirei = this.commonService.calcNichirei(edukeDate, hikakuDate);
      console.log('genzaiNichirei', genzaiNichirei);
      for (const tentouProgramRow of tentouProgramDoc.tentouProgram) {
        console.log('tentouProgramRow', tentouProgramRow);
        if (tentouProgramRow.startNichirei <= genzaiNichirei
          && genzaiNichirei <= tentouProgramRow.endNichirei) {
          return tentouProgramRow.tentouShoutouJikoku;
          break;
        }
      }
    }
    return [{start:'', end: ''}];
  }

  /**
   * eventTaishouIdsから飼養ロットのIDを取り出し、数値部分のみ返す
   * @param eventTaishouIds
   */
  getShiyoulotIdsFromEventTaishouIds(eventTaishouIds: string[]) {
    const keys = eventTaishouIds.filter((val: string) => {
      return val.endsWith(SHIYOULOT_KEY_SUFFIX);
    });
    return keys.map((val: string) => val.slice(0, -2));
  }

  /**
   * イベント実施モーダル開いた際、実施済みのイベントであれば、実施内容を入力フォームに反映
   * @param inputForm 型：T extends exceptKeyWithOptional<AbstractEventJisshiNaiyou, 'jisshiDate'>
   * @param selectedMeisais 型：U extends T
   * @param selectedMeisai
   */
  setInputForm2<T extends exceptKeyWithOptional<AbstractEventJisshiNaiyou, 'jisshiDate'>, U extends T>(inputForm: T, selectedMeisai: U) {
    if (selectedMeisai && selectedMeisai.jisshiDate) {
      this.commonService.keysOf(inputForm).forEach(key => {
        if (typeof selectedMeisai[key] !== 'undefined' && selectedMeisai[key] !== null) {
          inputForm[key] = selectedMeisai[key];
        }
      });
    }
  }

  /**
   * inputForm → meisaiに値を転写
   * @param inputForm 型：T extends exceptKeyWithOptional<AbstractEventJisshiNaiyou, 'jisshiDate'>
   * @param meisai 型：U extends T
   */
  inputForm2Event2<T extends exceptKeyWithOptional<AbstractEventJisshiNaiyou, 'jisshiDate'>>(inputForm: T, meisai: T) {
    this.commonService.keysOf(inputForm).forEach(key => {
      if (typeof inputForm[key] !== 'undefined' && inputForm[key] !== null) {
        meisai[key] = inputForm[key];
      }
    });
  }

  /**
   *
   * @param batch
   * @param ref
   * @param obj
   * @param id
   */
  batchSet(batch: firebase.firestore.WriteBatch, ref: firebase.firestore.CollectionReference<firebase.firestore.DocumentData>, obj: any, id = '') {
    if (!id) {
      batch.set(ref.doc(), Object.assign({}, obj));
    } else {
      batch.set(ref.doc(id), Object.assign({}, obj));
    }
  }

  /**
   * selectedEvents に追加、削除
   * @param eventMeisai
   */
  setSelectedEvents(eventMeisai: WithChecked<AbstractEvent>) {
    if (eventMeisai.checked) {
      // 一番初めにイベントがチェックされた場合
      if (this.commonService.objectIsEmpty(this.firstCheckedEvent)) {
        this.firstCheckedEvent = this.setFirstCheckedEvent(eventMeisai);
        // 選択したイベントのみチェックして、selectedEventsに追加
        const selectedEvent = this.eventList.find((event: WithChecked<AbstractEvent>) => { return event.id === eventMeisai.id; });
        if (selectedEvent) {
          selectedEvent.checked = true;
          this.selectedEvents.push(selectedEvent);
        }
      } else {
        // 既にイベントがチェックされている場合
        // eventListにあるcheckedEventの中で、未だselectedEventsにないeventのみ追加
        if (this.selectedEvents.some((selectedEvent: WithChecked<AbstractEvent>) => selectedEvent.id !== eventMeisai.id)) {
          this.selectedEvents.push(eventMeisai);
        }
      }
    } else {
      // selectedEvents から event を削除
      this.selectedEvents = this.selectedEvents.filter((selectedEvent: WithChecked<AbstractEvent>) => selectedEvent.id !== eventMeisai.id);
      if (!this.selectedEvents.length) {
        // selectedEventsが空の場合、イベントチェック外す、firstCheckedEvent初期化
        this.resetEventChecked();
      }
    }
  }

  /**
   * 似た内容のイベントを一括チェック、解除
   * @param isChecked
   */
  updateSimilarEventChecked(isChecked: boolean) {
    if (isChecked) {
      // 対象イベント全て一括チェック
      this.eventList.filter(event => {
        return this.checkEventSelectable(event);
      }).forEach(selectableEvent => {
        // 上記イベント全てにチェック
        selectableEvent.checked = true;
        const sameEventExist = this.selectedEvents.some(selectedEvent => selectedEvent.id === selectableEvent.id);
        // eventListにあるcheckedEventの中で、未だselectedEventsにないeventのみ追加
        if(!sameEventExist) {
          this.selectedEvents.push(selectableEvent);
        }
      });
    } else {
      this.resetEventChecked();
    }
  }

  /**
   * イベントが選択可能か判別
   * @param eventMeisai
   * @param exceptFirst HTML側で未選択状態の場合 false を返すフラグ
   */
  checkEventSelectable(eventMeisai: WithChecked<AbstractEvent> | ComparisonEvent, exceptFirst = false) {
    let isSelectable = false;
    // イベントが選択されている場合
    if (!this.commonService.objectIsEmpty(this.firstCheckedEvent)) {
      isSelectable = this.isSelectable(eventMeisai);
    } else if (!exceptFirst) {
      isSelectable = true;
    }
    return isSelectable;
  }

  /**
   * 最初に選択されたイベントと各イベント明細を比較し、選択可能か判別
   *
   * @param eventMeisai
   */
  isSelectable(eventMeisai: WithChecked<AbstractEvent> | ComparisonEvent) {
    let isSelectable = false;

    // 最初に選択されたイベントと比較
    const isSameEventShubetsu = this.firstCheckedEvent?.eventShubetsu === eventMeisai.eventShubetsu;
    const isSameTaishouKeisha = this.firstCheckedEvent?.taishouKeisha === eventMeisai.taishouKeisha;
    const isSameYoteiDate = this.firstCheckedEvent?.yoteiDate === eventMeisai.yoteiDate;

    switch (eventMeisai.eventShubetsu) {
      case VACCINE:
        // ワクチン： イベント種別,鶏舎,ワクチン株,投与方法が同じ場合、選択可能
        const isSameKabu = VACCINE_KABU in eventMeisai && this.firstCheckedEvent?.vaccineKabu === eventMeisai.vaccineKabu;
        const isSameHouhou = TOUYO_HOUHOU in eventMeisai && this.firstCheckedEvent?.touyoHouhou === eventMeisai.touyoHouhou;
        if (isSameEventShubetsu && isSameTaishouKeisha
          && isSameKabu && isSameHouhou) {
          isSelectable = true;
        }
        break;
      case TAISOKU:
        // 体測： イベント種別,鶏舎,イベント名, 餌付け日が同じ場合、選択可能(餌付け日は変更可能性有)
        // 体測のイベント名は「体測(x週齢)」
        const isSameEventName = this.firstCheckedEvent.eventName === eventMeisai.eventName;
        const isSameEdukeDate = this.firstCheckedEvent.taishouEdukeDate === eventMeisai.taishouEdukeDate;
        if (isSameEventShubetsu && isSameTaishouKeisha && isSameEventName && isSameEdukeDate) {
          isSelectable = true;
        }
        break;
      case SAIZAI:
        // 採材： イベント種別,鶏舎,予定日,種別が同じ場合、選択可能
        // 採材の種別が一致
        const isSameShubetsu = SHUBETSU in eventMeisai && this.firstCheckedEvent.shubetsu === eventMeisai.shubetsu;
        if (isSameEventShubetsu && isSameTaishouKeisha && isSameYoteiDate && isSameShubetsu) {
          isSelectable = true;
        }
        break;
      case SAIKETSU:
        // 採血： イベント種別,鶏舎,予定日が同じ場合、選択可能
        if (isSameEventShubetsu && isSameTaishouKeisha && isSameYoteiDate) {
          isSelectable = true;
        }
        break;
      default:
        if (this.firstCheckedEvent.id === eventMeisai.id) {
          // 既にチェックされているイベントの行をクリックした場合
          isSelectable = true;
        }
    }
    return isSelectable;
  }

  /**
   * eventList、selectedEvents で選択されているイベントを取得
   */
  getCheckedMeisai() {
    return this.eventList.filter(event => {
      return event.checked === true;
    }).concat(this.selectedEvents).filter((selectedEvent, index, self: WithChecked<AbstractEvent>[]) => {
      // https://cpoint-lab.co.jp/article/202107/20512/
      // idが重複する明細を削除する
      // id だけをリスト化する
      const ids = self.map(item => item.id);
      // 重複を削除する
      if (ids.indexOf(selectedEvent.id) === index) {
        return selectedEvent;
      }
      return false;
    });
  }

  /**
   * イベントリストのイベントチェック外す
   * firstCheckedEventを初期化
   */
  resetEventChecked() {
    this.allEventChecked = false; // イベント一括チェック
    this.selectedEvents = [];
    this.firstCheckedEvent = {};
    this.eventList.forEach((event: WithChecked<AbstractEvent>) => event.checked = false);
  }

  /**
   * イベント実施モーダルを開く
   */
  openJisshiNaiyouModal() {
    let selectedRows: WithChecked<AbstractEvent>[] = [];
    selectedRows = this.getCheckedMeisai();
    const component = this.getComponent();

    // イベント種別が体測の場合、選択された体測イベントの共通の項目(weights, mean, cv, jisshiDate, jisshiSha) が一致していない場合、returnする。
    if (this.firstCheckedEvent?.eventShubetsu === 'taisoku') {
      const hasDifferentTaisokuCommonProps = this.hasDifferentTaisokuCommonProps(selectedRows as TaisokuEvent[]);
      if (hasDifferentTaisokuCommonProps) {
        alert('異なる体測情報が登録されている作業があります。');
        return;
      }
    }

    const dialogRef = this.dialog.open<EventDialogComponent, AbstractEvent[]>(component, {
      data: cloneDeep(selectedRows),
      maxWidth: '70vw',
      minWidth: '70vw',
      height: '70vh',
      panelClass: 'dialog-with-close', // dialog外クリックでdialogを閉じる。
    });

    // 成功した場合のみ true が返ってくる
    return dialogRef.afterClosed().subscribe((result: boolean | undefined | null) => {
      if (!result) { return; }
      this.resetEventChecked();
    });
  }

  /**
   * 体測イベントの共通項目が一致しているか確認。
   * 登録済の体測イベントを複数選択された時に、異なる体測データを登録したデータが選択されている場合は
   * trueを返す。
   *
   * @param selectedRows
   */
  hasDifferentTaisokuCommonProps(selectedRows: TaisokuEvent[]) {
    // 複数選択された場合、各体測イベントで共通の項目(weights, mean, cv, jisshiDate, jisshiSha) が
    // 一致していない場合、trueをreturnする。
    const kijunJisshiZumiTaisoku = selectedRows.find(meisai => {return meisai.jisshiDate;});

    // 選択されたイベントが全て未実施の場合、falseをreturnする。
    // 未実施イベントと実施イベントが混在している場合は、trueをreturnする。
    // 実施済イベントがあれば、そのイベントを基準として、他のイベントと比較する。
    if (kijunJisshiZumiTaisoku) {
      // 体測イベントで比較するプロパティ名の配列
      const extractPropertyNames: (keyof TaisokuEvent)[] = ['weights', 'mean', 'cv', 'jisshiDate', 'jisshiSha'];

      // 登録済の体測イベントを基準として、体測イベントの共通の項目(weights, mean, cv, jisshiDate, jisshiSha) を比較する。
      const kijunCommonProps = this.commonService.extractProps(kijunJisshiZumiTaisoku, extractPropertyNames);

      // 各体側イベントと基準実施済体測イベントの共通の項目(weights, mean, cv, jisshiDate, jisshiSha) が一致していない場合、returnする。
      const hasDifferentCommonProps = selectedRows.some(meisai => {

        // 各体測イベントの比較プロパティを抽出
        const commonProps = this.commonService.extractProps(meisai, extractPropertyNames);

        // 共通項目を比較する。
        return !isEqual(kijunCommonProps, commonProps);
      });

      if (hasDifferentCommonProps) {
        return true;
      }
    }
    return false;
  }

  /**
   * イベント実施内容入力ダイアログを取得
   * 有り得ないが、デフォルトでは「その他」イベント追加ダイアログを返す
   */
  getComponent() {
    switch (this.firstCheckedEvent?.eventShubetsu) {
      case 'nyuuka':
        return NyuukaEventDialogComponent;
      case 'shukka':
        return ShukkaEventDialogComponent;
      case 'vaccine':
        return VaccineEventDialogComponent;
      case 'saizai':
        return SaizaiEventDialogComponent;
      case 'saiketsu':
        return SaiketsuEventDialogComponent;
      case 'taisoku':
        return TaisokuEventDialogComponent;
      case 'debeak':
        return DebeakEventDialogComponent;
      case 'other':
        return OtherEventDialogComponent;
      default:
        // 有り得ないが、デフォルトでは「その他」イベント追加ダイアログを返す
        return OtherEventDialogComponent;
    }
  }

  // https://stackoverflow.com/questions/52622061/how-to-use-input-type-file-in-angular-material/53546417#53546417
  /**
   *
   * @param event
   * @param fileInput
   * @param meisai
   * @param willUploadFileList
   */
  onFileSelected(event: Event, fileInput: HTMLInputElement, meisai: exceptKeyWithOptional<SaizaiSaiketsuJisshiNaiyou, 'jisshiDate'>, willUploadFileList: any) {
    console.log(event);
    console.log(fileInput);
    const target = event.target as HTMLInputElement;
    if (event.target && target.files) {
      const file = target.files[0];
      const domain = this.sessionService.session.personalSetting.customerId;
      meisai.filePath = domain + '/' + this.commonService.genUniqueStr() + '/' + file.name;
      const willUploadFile = {path: meisai.filePath, fileData: file};
      willUploadFileList.push(willUploadFile);
    }
  }

  /**
   *
   */
  willDeleteConfirm() {
    return confirm('添付ファイルを削除しますか？');
  }

  /**
   *
   * @param meisai
   * @param willUploadFileList
   * @param willDeleteFileList
   * @param blobURL
   */
  deleteUnUploadedFile(meisai: exceptKeyWithOptional<SaizaiSaiketsuJisshiNaiyou, 'jisshiDate'>, willUploadFileList: any, willDeleteFileList: any, blobURL?: SafeResourceUrl) {
    if (!meisai.filePath) { return; }
    if (this.willDeleteConfirm()) {
      willUploadFileList.filter((value: any) => value.path !== meisai.filePath);
      willUploadFileList.forEach((value: any, index: number) => {
        if (value.path == meisai.filePath) {
          willUploadFileList.splice(index, 1);
        }
      });
      if (blobURL) {
        willDeleteFileList.push(meisai.filePath);
      }
      delete meisai.filePath;
    }
  }

  /**
   * inputForm に実施日齢をセット
   * @param inputForm
   * @param edukeDate
   */
  updateJisshiNichirei2<T extends Partial<AbstractEventJisshiNaiyou>>(inputForm: T, edukeDate: string) {
    if (edukeDate && inputForm.jisshiDate) {
      inputForm.jisshiNichirei
        = this.commonService.calcNichirei(edukeDate, inputForm.jisshiDate);
    }
  }

  /**
   * weeks をセットする
   * @param kensakuKey
   */
  setCalendar(kensakuKey: EventSearchKey) {
    this.weeks = this.getCalendar(kensakuKey);
  }

  /**
   * 1ヶ月分の CalendarDay object をまとめた配列を返す
   * @param kensakuKey
   */
  getCalendar(kensakuKey: EventSearchKey): CalendarDay[][] {
    const weeks: CalendarDay[][] = [];
    // 月初
    const firstDayOfMonth = new Date(kensakuKey.year, kensakuKey.month-1, 1);
    const firstDateOfMonth = firstDayOfMonth.getDate();
    const firstDayOfWeek = firstDayOfMonth.getDay();
    const prevMonthStart = firstDateOfMonth - firstDayOfWeek;
    // 月末
    const lastDayOfMonth = new Date(kensakuKey?.year, kensakuKey?.month-1, 0);
    // １ヶ月の最大週
    const maxWeek = Math.ceil((lastDayOfMonth.getDate() - (7 - (firstDayOfWeek + 1))) / 7 + 1);

    let sum = 0;
    for (let i = 0; i < maxWeek; i++) {
      const days: CalendarDay[] = [];
      for (let j = 0; j < 7; j++) {
        const saveDate = new Date(firstDayOfMonth.getFullYear(), firstDayOfMonth.getMonth(), sum + prevMonthStart + j);
        days.push({
          day: saveDate.getDay(),
          date: saveDate.getDate(),
          month: saveDate.getMonth() + 1,
          year: saveDate.getFullYear(),
          windex: i + 1,
          dindex: saveDate.getDay() + 1
        });
      }
      sum += days.length;
      weeks.push(days);
    }
    return weeks;
  }

  /**
   * イベント一覧の行クリックで実施モーダルを開く
   * @param row
   */
  eventRowClicked(row: WithChecked<AbstractEvent>) {
    if (!this.checkEventSelectable(row)) { return; }
    row.checked = true;
    this.setSelectedEvents(row);
    // チェックされた場合、モーダルを開く
    if (row.checked) { this.openJisshiNaiyouModal(); }
  }

  /**
   * AbstractEventを返す
   * @param eventName
   * @param yoteiDate
   * @param eventTaishouIds
   * @param taishouLotName
   * @param taishouKeisha
   * @param taishouKeishu
   * @param taishouEdukeDate
   * @param yoteiNichirei
   * @param taishouShukkaSaki
   * @param willJisshi
   */
  getAbstractEvent(eventName: string, yoteiDate: string, eventTaishouIds: any[],
    taishouLotName: string, taishouKeisha: string, taishouKeishu: string,
    taishouEdukeDate: string, yoteiNichirei: number, taishouShukkaSaki: string[],
    willJisshi = true, jisshiDate: string | null = null
  ): AbstractEvent {
    return {
      eventName,
      yoteiDate,
      eventTaishouIds,
      taishouLotName,
      taishouKeisha,
      taishouKeishu,
      taishouEdukeDate,
      yoteiNichirei,
      taishouShukkaSaki,
      willJisshi,
      jisshiDate
    };
  }

  /**
   * ワクチンイベント新規作成処理
   * @param abstractEvent       全イベント共通プロパティをもつオブジェクト
   * @param vaccineEvent
   */
  getVaccineEvent(abstractEvent: AbstractEvent, vaccineEvent: EventForEdit<VaccineEvent>): VaccineEvent {
    const eventShubetsu = {
      kind: COLLECTION_NAME.EVENT,
      eventShubetsu: VACCINE,
      eventShubetsuName: VACCINE_KANA,
    } as const;
    return Object.assign(eventShubetsu, vaccineEvent as VaccineEvent, abstractEvent);
  }

  /**
   * 採材イベント新規作成処理
   * @param abstractEvent
   * @param saizaiEvent
   */
  getSaizaiEvent(abstractEvent: AbstractEvent, saizaiEvent: EventForEdit<SaizaiEvent>): SaizaiEvent {
    const eventShubetsu = {
      kind: COLLECTION_NAME.EVENT,
      eventShubetsu: SAIZAI,
      eventShubetsuName: SAIZAI_KANA,
    } as const;
    return Object.assign(eventShubetsu, saizaiEvent as SaizaiEvent, abstractEvent);
  }

  /**
   * 採血イベント新規作成処理
   * @param abstractEvent
   */
  getSaiketsuEvent(abstractEvent: AbstractEvent): SaiketsuEvent {
    const eventShubetsu = {
      kind: COLLECTION_NAME.EVENT,
      eventShubetsu: SAIKETSU,
      eventShubetsuName: SAIKETSU_KANA,
    } as const;
    return Object.assign(eventShubetsu, abstractEvent);
  }

  /**
   * デビークイベント新規作成処理
   * @param abstractEvent
   */
  getDebeakEvent(abstractEvent: AbstractEvent): DebeakEvent {
    const eventShubetsu = {
      kind: COLLECTION_NAME.EVENT,
      eventShubetsu: DEBEAK,
      eventShubetsuName: DEBEAK_KANA,
    } as const;
    return Object.assign(eventShubetsu, abstractEvent);
  }

  /**
   * 入荷イベント新規作成処理
   * @param abstractEvent
   * @param nyuukaEvent
   */
  getNyuukaEvent(abstractEvent: AbstractEvent, nyuukaEvent: EventForEdit<NyuukaEvent>): NyuukaEvent {
    const eventShubetsu = {
      kind: COLLECTION_NAME.EVENT,
      eventShubetsu: NYUUKA,
      eventShubetsuName: NYUUKA_KANA,
      yoteiNyuukaWasuu: 0,
      himodukiId: null,
    } as const;
    return Object.assign(eventShubetsu, nyuukaEvent, abstractEvent);
  }

  /**
   * 出荷イベント新規作成処理
   * shukkaSakiId, shukkaKeishaId の初期値は null だが
   * ShukkaEvent インターフェースでは null 許容しない。
   * (保存時に null 許容しない)
   * @param abstractEvent
   * @param shukkaEvent
   */
  getShukkaEvent(abstractEvent: AbstractEvent, shukkaEvent: EventForEdit<ShukkaEvent>): WithNullable<ShukkaEvent, 'shukkaSakiId' | 'shukkaKeishaId'> {
    const eventShubetsu = {
      kind: COLLECTION_NAME.EVENT,
      eventShubetsu: SHUKKA,
      eventShubetsuName: SHUKKA_KANA,
      toShiyoulot: true,
      shukkaSakiId: null,
      shukkaKeishaId: null,
      yoteiShukkaWasuu: 0,
      himodukiId: null,
    } as const;
    return Object.assign(eventShubetsu, shukkaEvent, abstractEvent);
  }

  /**
   * 飼養ロットからオールアウト用の出荷イベントを生成する。
   * オールアウト処理は即時実行するため、実施日には操作当日をセット
   * @param shiyoulot
   */
  public genShukkaEventForAllOut(shiyoulot: ShiyoulotV2): JisshiDateNonNullable<ShukkaEvent> {
    const today = this.commonService.getDateWithString();
    return {
      eventName: SHUKKA_EVENT_NAME.ALL_OUT,
      eventShubetsu: SHUKKA,
      eventShubetsuName: SHUKKA_KANA,
      eventTaishouIds: this.getEventTaishouIds(shiyoulot),
      himodukiId: null,
      jisshiDate: today,
      jisshiSha: this.sessionService.session.personalSetting.name,
      kind: COLLECTION_NAME.EVENT,
      shukkaKeishaId: '',
      shukkaSakiId: '',
      shukkaWasuu: 0, // transaction内で指定したいのでここでは0にしておく。
      taishouEdukeDate: shiyoulot.edukeDate,
      taishouKeisha: shiyoulot.keishaId!,
      taishouKeishu: shiyoulot.keishuId!,
      taishouLotName: shiyoulot.name!,
      taishouShukkaSaki: [],
      toShiyoulot: false,
      willJisshi: true,
      yoteiDate: today,
      yoteiNichirei: this.commonService.calcNichirei(shiyoulot.edukeDate, today),
      yoteiShukkaWasuu: 0
    };
  }

  /**
   * イベント対象idsを返す
   * @param shiyoulot
   */
  getEventTaishouIds(shiyoulot: ShiyoulotV2) {
    const ids: string[] = [];
    ids.push(shiyoulot.id + SHIYOULOT_KEY_SUFFIX);
    if (shiyoulot.keishaId) {
      ids.push(shiyoulot.keishaId);
      ids.push(this.commonService.getName(this.masterService.keishaMaster, shiyoulot.keishaId, 'farmId'));
    }
    if (shiyoulot.keishuId) { ids.push(shiyoulot.keishuId); }
    return ids;
  }

  /**
   * その他イベント新規作成処理
   * @param abstractEvent
   */
  getOtherEvent(abstractEvent: AbstractEvent): OtherEvent {
    const eventShubetsu = {
      kind: COLLECTION_NAME.EVENT,
      eventShubetsu: OTHER,
      eventShubetsuName: OTHER_KANA,
    } as const;
    return Object.assign(eventShubetsu, abstractEvent);
  }

  /**
   * 体測イベント新規作成処理
   * @param abstractEvent
   */
  getTaisokuEvent(abstractEvent: AbstractEvent): TaisokuEvent {
    const eventShubetsu = {
      kind: COLLECTION_NAME.EVENT,
      eventShubetsu: TAISOKU,
      eventShubetsuName: TAISOKU_KANA,
    } as const;
    return Object.assign(eventShubetsu, abstractEvent);
  }

  /**
   * イベント検索キー初期値を返す
   */
  getInitialEventSearchKey(): EventSearchKey {
    const todayString = this.commonService.getDateWithString();
    const year = Number(todayString.split('-')[0]);
    const month = Number(todayString.split('-')[1]);

    return {
      year: year,
      month: month,
      fromDate: '',
      toDate: '',
      isMiJisshi: true,
      eventTaishouIds: [''],
      willJisshi: true
    };
  }

  /**
   * １番目に選択されたイベントから比較に必要なプロパティをまとめたオブジェクト(ComparisonEvent)を返す
   * @param event
   */
  setFirstCheckedEvent(event: ComparisonEvent | WithChecked<AbstractEvent>): ComparisonEvent {
    return {
      id: event.id,
      yoteiDate: event.yoteiDate,
      eventShubetsu: event.eventShubetsu,
      eventName: event.eventName,
      taishouKeisha: event.taishouKeisha,
      taishouEdukeDate: event.taishouEdukeDate,
      vaccineKabu: VACCINE_KABU in event ? event.vaccineKabu : undefined,
      touyoHouhou: TOUYO_HOUHOU in event ? event.touyoHouhou : undefined,
      shubetsu: SHUBETSU in event ? event.shubetsu : undefined,
    };
  }

  /**
   * AbstractEventJisshiNaiyou の初期値セットしたObjectを返す
   */
  getInitialAbstractEventJisshiNaiyou(): exceptKeyWithOptional<AbstractEventJisshiNaiyou, 'jisshiDate'> {
    return {
      jisshiSha: this.sessionService.session.personalSetting.name,
      jisshiDate: this.commonService.getDateWithString(),
      jisshiNichirei: 0
    };
  }

  /**
   * SaizaiSaiketsuJisshiNaiyou の初期値セットしたObjectを返す
   */
  getInitialSaizaiSaiketsuJisshiNaiyou(): exceptKeyWithOptional<SaizaiSaiketsuJisshiNaiyou, 'jisshiDate'> {
    const result: exceptKeyWithOptional<SaizaiSaiketsuJisshiNaiyou, 'jisshiDate'> = this.getInitialAbstractEventJisshiNaiyou();
    result.filePath = undefined;
    return result;
  }

  /**
   * 必要に応じて目標温度設定を切り替える
   * @param nyuukaEvent
   */
  async setMokuhyouTemperature(nyuukaEvent: NyuukaEvent) {
    // 鶏舎マスタ取得、鶏舎Configを取得
    const keisha = this.masterService.keishaMaster
      .find(keisha => keisha.id === nyuukaEvent.taishouKeisha);
    if (!keisha) { return; }
    const mokuhyouTemperatureId: string
      = this.commonService.getName(this.masterService.keishuMaster, nyuukaEvent.taishouKeishu, 'mokuhyouTemperatureId');
    if (!mokuhyouTemperatureId) { return; }
    const keishaConfig = await this.getKeishaConfig(keisha.id);
    if (!keishaConfig) { return; }
    // On/offを確認
    if (!keishaConfig.autoSetMokuhyouTemperature) { return; }
    // 現在の目標温度設定idと変更後の目標温度設定idが同じ場合、変更しない
    if (keishaConfig.currentMokuhyouTemperatureId === mokuhyouTemperatureId) { return; }
    // Onなら入荷した鶏種に基づいて変更するかconfirm
    if (!confirm(this.getConfirmMsgForMtName(keishaConfig.currentMokuhyouTemperatureId, mokuhyouTemperatureId))) { return; }
    // trueならkeishaConfig→mtm確認してkeishaConfigに値をセット
    keishaConfig.currentMokuhyouTemperatureId = mokuhyouTemperatureId;
    this.setMokuhyouTemperatureMaster(keishaConfig, this.masterService.mokuhyouTemperatureMaster, mokuhyouTemperatureId);
    // originalMokuhyouTemperatureMasterがあればそちらで上書き
    this.setOriginalMokuhyouTemperatureMaster(keishaConfig, mokuhyouTemperatureId);
    const keishaConfigRef = this.genKeishaConfigRef(keisha.id);
    keishaConfigRef.set(keishaConfig, {merge: true}).then(() => {
      this.messageService.pushInfo('目標温度設定を更新しました');
    }).catch(e => {
      console.log(e);
      this.messageService.pushError('目標温度設定の更新に失敗しました');
    });
  }

  /**
   * 目標温度設定の切り替え確認メッセージを返す
   * @param prevMtId
   * @param currentMtId
   */
  getConfirmMsgForMtName(prevMtId: string, currentMtId: string) {
    const prevMtmName = this.getMtName(prevMtId);
    const currMtmName = this.getMtName(currentMtId);
    return '目標温度設定を切り替えますか?\n\n' + prevMtmName + '　→　' + currMtmName;
  }

  /**
   * 目標温度設定idから目標温度設定の名前を返す
   * @param mokuhyouTemperatureId 'free' or id が入り得る
   */
  getMtName(mokuhyouTemperatureId: string) {
    const mtm = this.masterService.mokuhyouTemperatureMaster.find(mtm => mtm.id === mokuhyouTemperatureId);
    return mtm ? mtm.name : 'カスタマイズ';
  }

  /**
   * 指定された鶏舎のkeishaConfigへのreferenceを生成
   * @param keishaId
   * @private
   */
  private genKeishaConfigRef(keishaId: string) {
    const keishaRef = this.genCustomerRootCollectionRef(COLLECTION_NAME.KEISHAMASTER).doc(keishaId);
    return keishaRef.collection(COLLECTION_NAME.KEISHACONFIG).doc(DOCUMENT_NAME.KEISHACONFIGDOC);
  }

  /**
   * originalMokuhyouTemperatureMasterがあれば
   * そちらで定義された目標温度設定をkeishaConfigにセット
   * @param keishaConfig
   * @param mokuhyouTemperatureId
   * @private
   */
  private setOriginalMokuhyouTemperatureMaster(keishaConfig: KeishaConfig, mokuhyouTemperatureId: string) {
    if (keishaConfig.originalMokuhyouTemperatureMaster && keishaConfig.originalMokuhyouTemperatureMaster.length) {
      this.setMokuhyouTemperatureMaster(keishaConfig, keishaConfig.originalMokuhyouTemperatureMaster, mokuhyouTemperatureId);
    }
  }

  /**
   * 目標温度設定をkeishaConfigにセット
   * @param keishaConfig
   * @param mokuhyouTemperatureMaster
   * @param mokuhyouTemperatureId
   * @private
   */
  private setMokuhyouTemperatureMaster(keishaConfig: KeishaConfig, mokuhyouTemperatureMaster: { id: string, mokuhyouTemperatureRows: MokuhyouTemperatureRow[] }[], mokuhyouTemperatureId: string) {
    const originalMtm
      = mokuhyouTemperatureMaster.find(mtm => mtm.id === mokuhyouTemperatureId);
    if (originalMtm) {
      keishaConfig.currentMokuhyouTemperatureRows = originalMtm.mokuhyouTemperatureRows;
    }
  }

  /**
   * 飼養ロットに紐づく出荷イベントをコピーする
   * イベント実施内容、id プロパティ削除
   * @param shiyoulotId
   */
  async copyShukkaEvent() {
    // TODO 鶏舎idを指定
    const keishaId = 'ZQ6RxsxJDt5tXHhufLtW';
    const shiyoulotIds: string[] = [];
    const shiyoulotRef = this.genCustomerRootCollectionRef(COLLECTION_NAME.SHIYOULOT);
    await shiyoulotRef.where('keishaId', '==', keishaId)
      .where('isExist', '==', true)
      .get().then((querySnapshot) =>{
        querySnapshot.forEach(shiyoulotDoc => {
          const shiyoulotId = shiyoulotDoc.id;
          shiyoulotIds.push(shiyoulotId);
        })
      });

    for (const shiyoulotId of shiyoulotIds) {
      if (!confirm('ロット番号：' + shiyoulotId + 'の出荷イベントをコピーしますか？')) { continue; }
      const shiyoulotKey = shiyoulotId + SHIYOULOT_KEY_SUFFIX;
      const eventKensakuKey: Partial<EventSearchKey> = {
        eventTaishouIds: [shiyoulotKey],
        willJisshi: true,
        eventShubetsu: 'shukka'
      }
      const shukkaEvents = (await this.getEvent(eventKensakuKey)) as ShukkaEvent[];
      const shukkaEventJisshiProperties = [
        'id',
        'jisshiSha',
        'shukkaWasuu',
        'jisshiNichirei'
      ];

      const batch = this.db.firestore.batch();
      const customerRef = this.genCustomerRootCollectionRef(COLLECTION_NAME.EVENT);
      if (shukkaEvents.length) {
        // 出荷イベントからプロパティ削除
        this.commonService.deletePropertiesFromObject(shukkaEvents, shukkaEventJisshiProperties);
        shukkaEvents.forEach(shukkaEvent => {
          // 未実施作業のみ表示で表示されないため。
          shukkaEvent.jisshiDate = null;
          batch.set(customerRef.doc(), shukkaEvent);
        })
      }
      batch.commit().then();
    }
  }
}
